module.exports = __webpack_public_path__ + "img/55.9ee7b034.jpg";